import { composeIncludeString } from '../api-utilities/compose-include-string';

const INCLUDED_CONSTRUCTION_NUMBER_PROPERTIES = <const>[
    'areaProjectId',
    'districtId',
    'projectPhaseId',
    'projectPhaseName',
    'propertyTypeId',
    'propertyTypeName',
    'apartmentBuildingId',
    'identifier',
    'wishlistItemCount',
    'availabilityStatus',
    'geometry',
    'mainImage',
    'specifications',
    'salesPrice',
    'rentalPrice',
    'numberOfReserveCandidates',
    'gardens',
    'outsideSpace',
    'isEnergyNeutral',
];

const INCLUDED_PROPERTY_TYPE_PROPERTIES = <const>[
    'areaProjectId',
    'districtId',
    'projectPhaseId',
    'projectPhaseName',
    'name',
    'houseType',
    'isRental',
    'geometry',
    'mainImage',
    'specifications',
    'salesPrice',
    'rentalPrice',
    'canShowPrice',
];

const INCLUDED_PROJECT_PHASE_PROPERTIES = <const>[
    'areaProjectId',
    'areaProjectName',
    'districtId',
    'name',
    'url',
    'districtUrl',
    'shortDescription',
    'status',
    'saleStartDate',
    'saleEndDate',
    'allocationDate',
    'isRental',
    'location',
    'geometry',
    'mainImage',
    'propertySpecifications',
    'propertyPurchasePrice',
    'propertyRentalPrice',
    'customerJourneyMilestones',
    'houseTypes',
];

const INCLUDED_APARTMENT_BUILDING_PROPERTIES = <const>[
    'areaProjectId',
    'projectPhaseId',
    'projectPhaseName',
    'displayName',
    'nodeId',
    'propertyTypeIds',
    'constructionNumberIds',
    'image',
    'geometry',
    'views',
];

const INCLUDED_DISTRICT_PROPERTIES = <const>[
    'areaProjectId',
    'name',
    'url',
    'location',
    'geometry',
    'descriptionTitle',
    'description',
    'image',
];

const INCLUDED_AREA_PROJECT_PROPERTIES = <const>[
    'name',
    'shortDescription',
    'regionId',
    'url',
    'isCompleted',
    'image',
    'location',
    'geometry',
    'website',
    'mapboxDatasetId',
    'mapboxTilesetId',
];

const INCLUDED_PROPERTIES = {
    constructionNumber: INCLUDED_CONSTRUCTION_NUMBER_PROPERTIES,
    propertyType: INCLUDED_PROPERTY_TYPE_PROPERTIES,
    projectPhase: INCLUDED_PROJECT_PHASE_PROPERTIES,
    apartmentBuilding: INCLUDED_APARTMENT_BUILDING_PROPERTIES,
    district: INCLUDED_DISTRICT_PROPERTIES,
    areaProject: INCLUDED_AREA_PROJECT_PROPERTIES,
};

const COMPOSED_INCLUDE_STRINGS = {
    constructionNumber: composeIncludeString([...INCLUDED_CONSTRUCTION_NUMBER_PROPERTIES]),
    propertyType: composeIncludeString([...INCLUDED_PROPERTY_TYPE_PROPERTIES]),
    projectPhase: composeIncludeString([...INCLUDED_PROJECT_PHASE_PROPERTIES]),
    apartmentBuilding: composeIncludeString([...INCLUDED_APARTMENT_BUILDING_PROPERTIES]),
    district: composeIncludeString([...INCLUDED_DISTRICT_PROPERTIES]),
    areaProject: composeIncludeString([...INCLUDED_AREA_PROJECT_PROPERTIES]),
};

export { COMPOSED_INCLUDE_STRINGS, INCLUDED_PROPERTIES };
